// Polish — neutered to remove the floating "New To-Do" + "New Note"
// icon-button cluster that appeared in the top-right of every page's
// header band. The cluster was unused, visually noisy, and took up
// header space that the page content could use.
//
// Kept the file (returns null) instead of deleting it because the
// mount lives in AppShell.tsx (frozen file per CLAUDE.md operating
// rule §4). A future ticket that opens AppShell.tsx for other reasons
// should remove this dead mount + this stub in the same commit.
export default function GlobalQuickAdd() {
  return null;
}
